import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { id: "500" } },
    [
      _c(
        VContainer,
        { attrs: { "fill-height": "", fluid: "" } },
        [
          _c(
            VRow,
            { staticClass: "justify-center no-wrap" },
            [
              _c(
                VCard,
                {
                  staticClass: "justify-center text-no-wrap",
                  attrs: { flat: "" },
                },
                [
                  _c(
                    VCardText,
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { staticClass: "mr-3 hidden-sm-and-down" },
                            [
                              _c("img", {
                                attrs: {
                                  alt: "",
                                  src: "/static/error/500.svg",
                                },
                              }),
                            ]
                          ),
                          _c(VCol, [
                            _c("h1", [_vm._v("500")]),
                            _c("h2", { staticClass: "my-3 headline" }, [
                              _vm._v(" Ops, aconteceu um erro inesperado. "),
                            ]),
                            _c(
                              "div",
                              [
                                _c(
                                  VBtn,
                                  {
                                    attrs: { color: "primary" },
                                    on: { click: _vm.goHome },
                                  },
                                  [_vm._v(" Página Inicial ")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }